import { isEmpty } from 'ramda';
import { createAction } from 'redux-actions';

import { replaceData } from '@gef-ui/form-core/stream/transfer/control';

import { COMPANY } from 'constants/general';
import fetch from 'features/common/fetch';
import campaignDetail from 'features/views/campaignManagement/campaignDetail';
import {
	getCampaignSubsellerNominationsFilter,
	getCampaignSubsellerNominationsInitialOrgStructure,
} from 'features/views/campaignSubsellerNomination/selectors';
import user from 'features/views/user';
import { USER_ROLE } from 'features/views/user/constants';

import * as types from './actionTypes';
import { CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME } from './form';

export const submitFilter = createAction(types.UPDATE_FILTER, (filter) => ({ filter }));
export const resetFilter = createAction(types.RESET_FILTER);
export const setInitialOrgStructure = createAction(types.SET_INITIAL_ORG_STRUCTURE, (initialOrgStructure) => ({
	initialOrgStructure,
}));

export const initializeOrganizationStructure =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		const campaign = campaignDetail.selectors.getCampaignDetail(getState());
		const roleStructure = user.selectors.getRoleStructure(getState());
		const allowedChannels = user.selectors.getAllowedChannels(getState());
		const currentRole = user.selectors.getCurrentRole(getState());
		const subsellerNominationsFilter = getCampaignSubsellerNominationsFilter(getState());

		if (
			[USER_ROLE.GROUP_MANAGER, USER_ROLE.DISTRICT_MANAGER].includes(currentRole) &&
			allowedChannels &&
			allowedChannels.includes(campaign?.channelId) &&
			isEmpty(subsellerNominationsFilter)
		) {
			const data = {
				channel: campaign?.channelId,
				region: roleStructure?.regionId,
				agency: roleStructure?.agencyId,
				manager: roleStructure?.managerLogin,
			};

			dispatch(submitFilter(data));
			dispatch(setInitialOrgStructure(data));
			sendControlNext(CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME, replaceData({ data }));
		} else {
			const data = {
				channel: subsellerNominationsFilter.channel,
				region: subsellerNominationsFilter.region,
				agency: subsellerNominationsFilter.agency,
				manager: subsellerNominationsFilter.manager,
			};
			dispatch(setInitialOrgStructure(data));
			sendControlNext(CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME, replaceData({ data }));
		}
	};

export const resetSubsellerNominations =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		const initialOrgStructure = getCampaignSubsellerNominationsInitialOrgStructure(getState());
		dispatch(submitFilter(initialOrgStructure));
		sendControlNext(CAMPAIGN_SUBSELLER_NOMINATIONS_FORM_NAME, replaceData({ data: initialOrgStructure }));
	};

export const fetchSellers = (channelId, regionId, agencyId, managerLogin, fetchSuffix) => (dispatch) => {
	const companyId = COMPANY.CP;

	return dispatch(
		fetch.actions.get(fetch.constants.urls.orgStructureSellers, {
			uniqueReqID: fetchSuffix,
			queryParams: {
				companyId,
				channelId,
				regionId,
				agencyId,
				managerLogin,
			},
		}),
	);
};

export const fetchPPZ = (channelId, regionId, agencyId, managerLogin, sellerLogin, fetchSuffix) => (dispatch) => {
	const companyId = COMPANY.CP;

	return dispatch(
		fetch.actions.get(fetch.constants.urls.orgStructurePPZ, {
			uniqueReqID: fetchSuffix,
			queryParams: {
				companyId,
				channelId,
				regionId,
				agencyId,
				managerLogin,
				sellerLogin,
			},
		}),
	);
};

export const updateNominations = (campaignId, nominatedSellerLogin) => (dispatch) => {
	return dispatch(
		fetch.actions.put(fetch.constants.urls.campaignNominations, {
			uniqueReqID: `update.${nominatedSellerLogin}`,
			replaceParams: {
				id: campaignId,
			},
			queryParams: {
				nominatedSeller: nominatedSellerLogin,
			},
		}),
	);
};

export const deleteNomination = (campaignId, nominatedSellerLogin) => (dispatch) => {
	return dispatch(
		fetch.actions.deleteRequest(fetch.constants.urls.campaignNominations, {
			uniqueReqID: `update.${nominatedSellerLogin}`,
			replaceParams: {
				id: campaignId,
			},
			queryParams: {
				nominatedSeller: nominatedSellerLogin,
			},
		}),
	);
};
